module.exports = __webpack_public_path__ + "img/pagination-CO2Activated.3af41e38.svg";